import { render, staticRenderFns } from "./termlyModePending.vue?vue&type=template&id=163a47fe&scoped=true"
import script from "./termlyModePending.vue?vue&type=script&lang=js"
export * from "./termlyModePending.vue?vue&type=script&lang=js"
import style0 from "./termlyModePending.vue?vue&type=style&index=0&id=163a47fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a47fe",
  null
  
)

export default component.exports